import { Injectable } from '@angular/core';

// To avoid errors while compiling, 
// bc service fnx are returning objects with types 
// declared in the @mycure/sdk
import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

import { Logger } from '../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McAccountService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  /**
   * Get account membership and uid
   */
  async loadCurrentUserIdMembership() {
    const currentUser: any = await this.sdk.auth().currentUser();
    if (!currentUser) throw new Error('no user');

    const membership = await this.sdk.organization.members().findOne({ uid: currentUser.uid });
    if (!membership) throw new Error('no membership');

    return { currentUser, membership };
  }

  /**
   * Get account uid
   */
  async loadUserId() {
    const currentUser: any = await this.sdk.auth().currentUser();
    if (!currentUser) throw new Error('no user');
    return currentUser;
  }

  /**
   * Load all memberships of an organization
   * @param orgId 
   */
  async loadAllOrgMembership(orgId: string) {
    const query = { organization: orgId };
    const memberships = await this.sdk.organization.members().find(query);
    const members = memberships.items;
    const memberIds = members.map((item: any) => item.uid) || [];
    return { members, memberIds };
  }
}
